var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy_all"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.875 1.5H7.125C6.3 1.5 5.625 2.175 5.625 3V12C5.625 12.825 6.3 13.5 7.125 13.5H13.875C14.7 13.5 15.375 12.825 15.375 12V3C15.375 2.175 14.7 1.5 13.875 1.5ZM13.875 12H7.125V3H13.875V12ZM2.625 11.25V9.75H4.125V11.25H2.625ZM2.625 7.125H4.125V8.625H2.625V7.125ZM7.875 15H9.375V16.5H7.875V15ZM2.625 13.875V12.375H4.125V13.875H2.625ZM4.125 16.5C3.3 16.5 2.625 15.825 2.625 15H4.125V16.5ZM6.75 16.5H5.25V15H6.75V16.5ZM10.5 16.5V15H12C12 15.825 11.325 16.5 10.5 16.5ZM4.125 4.5V6H2.625C2.625 5.175 3.3 4.5 4.125 4.5Z",
    fill: "#5B6670"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAll);
export default __webpack_public_path__ + "static/media/CopyAll.6b4ee3659f3be1460a723cfffc4ec863.svg";
export { ForwardRef as ReactComponent };